import axios from "api/api/axios"

export type AISearchItem = {
  id: number
  name: string
  urlSegment: string
  sortOrder: number
  level: number
  path: string
  createDate: string | null
  updateDate: string | null
  key: string
  url: string
  titleBreadcrumbs: string
  searchKeyword: string
  description: string
  imageUrl: string | null
}

export type AISearchResponse = {
  errorCode: number
  body: {
    items: AISearchItem[]
    pageSize: number
    pageIndex: number
    totalRecords: number
    term: string
  } | null
}

export async function fetchAISearchResults(
  text: string,
  site?: string,
): Promise<AISearchItem[]> {
  const params: Record<string, string> = { s: text, pageSize: "10" }
  if (site) {
    params.site = site
  }
  const { data } = await axios.get<AISearchResponse>("/web/search", { params })
  if (data.errorCode !== 0 || !data.body) {
    throw new Error(`Search error: ${data.errorCode}`)
  }
  return data.body.items
}
